import { useEffect } from 'react'

import { useAppSelector } from 'reduxTyped'
import { getUserRole } from 'common/userRoles'
import { UserRoles } from 'common/userRoles/userRolesInterfaces'
import { ZendeskApi } from 'shared/api/requests/zendesk'
import { FailedToStoreZendeskSessionInfoError } from 'shared/errors/serviceLayerError'
import { getAccountID } from 'utils/accountId'

import errorTrackingService from '../errorTrackingService'

export const useSessionInfo = () => {
  const userRole = useAppSelector(getUserRole)
  useEffect(() => {
    const accountId = getAccountID()
    if (!accountId) return

    if (![UserRoles.ADMIN, UserRoles.EDITOR].includes(userRole)) return

    ZendeskApi.sessionPageId({
      body: { page_id: accountId },
    }).catch((err) => {
      errorTrackingService.logError(new FailedToStoreZendeskSessionInfoError(), {
        scope: 'support',
        section: 'session_info',
        extra: {
          accountId,
          err,
        },
      })
    })
  }, [userRole])
}
